<template>
  <div class="page">
    <div class="page-header">
      <h1 class="page-title">Samurai</h1>
      <breadcrumb name="GAME_SAMURAI_SETTINGS"></breadcrumb>
      <div class="page-header-actions"></div>
    </div>

    <div class="page-content page-content-table">
      <div class="container-fluid">
        <div class="row">
          <div class="col-xl-12 col-lg-12">
            <div class="panel settings-panel">
              <div class="panel-heading">
                <h3 class="panel-title">Non-Ufu Environments</h3>
                <div class="panel-actions panel-actions-keep"></div>
              </div>
              <div class="panel-body p-0">
                <vue-good-table
                  :rows="nonUfuRows"
                  :columns="columns"
                  @on-row-click="openEnvironment"
                />
              </div>
            </div>

            <div class="panel settings-panel">
              <div class="panel-heading">
                <h3 class="panel-title">Ufu Environments</h3>
                <div class="panel-actions panel-actions-keep"></div>
              </div>
              <div class="panel-body p-0">
                <vue-good-table
                  :rows="ufuRows"
                  :columns="columns"
                  @on-row-click="openEnvironment"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal :name="modalName" :width="860" height="auto" @closed="clearSelected">
      <ConfigurationModal
        :name="modalName"
        :themes="choices"
        @updated="onConfigUpdated"
        :environment="selected.environment"
      />
    </modal>
  </div>
</template>

<script>
import { gameSamuraiService } from "@/api/client";
import { configTableColumns as columns } from "@/views/samurai/Settings/model";
import ConfigurationModal from "@/views/samurai/Settings/components/ConfigurationModal.vue";

export default {
  model: "GameSamuraiSettings",

  data() {
    return {
      nonUfuRows: [],
      ufuRows: [],
      choices: [],
      columns: columns,
      selected: { environment: null },
      modalName: "samurai-configuration-modal",
    };
  },

  components: { ConfigurationModal },

  methods: {
    isUfuCode(code) {
      return /^ufu\d+$/i.test(code || "");
    },

    async openEnvironment(event) {
      if (this.isUfuCode(event.row.code)) {
        // Ufu settings use the new route-based detail flow.
        this.$router
          .push({
            name: "GameSamuraiSettingsDetail",
            params: { code: event.row.code },
          })
          .catch(() => {});
        return;
      }

      this.selected = { environment: event.row };
      this.$modal.show(this.modalName);
    },

    async fetchEnvironment() {
      try {
        const [nonUfuGroups, ufuGroups] = await Promise.all([
          gameSamuraiService.getNonUfuGroups(),
          gameSamuraiService.getUfuGroups(),
        ]);

        this.nonUfuRows = Array.isArray(nonUfuGroups) ? nonUfuGroups : [];
        this.ufuRows = Array.isArray(ufuGroups) ? ufuGroups : [];
      } catch (error) {
        const groups = await gameSamuraiService.getAllGroup();

        this.nonUfuRows = groups.filter((group) => !this.isUfuCode(group.code));
        this.ufuRows = groups.filter((group) => this.isUfuCode(group.code));
      }
    },

    async fetchChoices() {
      const choices = await gameSamuraiService.getThemeChoice();
      this.choices = choices;
    },

    clearSelected() {
      this.selected.environment = null;
    },

    // Events
    onConfigUpdated() {
      this.fetchEnvironment();
      this.clearSelected();
    },
  },

  created() {
    this.fetchChoices();
    this.fetchEnvironment();
  },
};
</script>

<style lang="scss" scoped>
.settings-panel {
  overflow: hidden;
  margin-bottom: 1.5rem;
}

.settings-panel > .panel-heading {
  border-bottom: 1px solid #e4eaec;
}
</style>
